import { Typography } from "@mui/material";

export default function BarChartComponent({ title, chartComponent }) {
  return (
    <div
      className="w-full flex-col justify-center items-center content-center shadow-sm chart33"
      style={{
        borderRadius: "10px",
        boxShadow:
          "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
      }}
    >
      <div className="my-2">
        <Typography
          sx={{ fontSize: "0.8em", fontWeight: 400, textAlign: "center" }}
        >
          <b>{title}</b>
        </Typography>
      </div>
      <div style={{ padding: "0px 10px 0px 10px" }}>{chartComponent}</div>
    </div>
  );
}
